var _effectorFileName = "/builds/gmini/front-ui-kit/src/SearchInput/SearchInput.styled.ts";
import styled from 'styled-components';
export const Input = styled.input`
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background: rgba(53, 59, 96, 0.05);
  color: rgba(0, 0, 0, 0.87);
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0.1px;
  outline: none;
  padding: 11px 35px 11px 12px;
  transition: background-color 0.2s ease-out, box-shadow 0.2s ease-out,
    border-color 0.2s ease-out;
  border: 1px solid transparent;

  &::placeholder {
    color: #b5b5b6;
    font-weight: 500;
  }

  &:focus {
    background: #fff;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
    border: 1px solid #edeff3;
  }
`;
export const InputWrapper = styled.div`
  width: 100%;
  height: 40px;
  position: relative;
`;
export const InputIconWrapper = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  right: 9px;
  top: 50%;
  transform: translateY(-50%);
`;
export const MagnifierWrapper = styled(InputIconWrapper)`
  width: 24px;
`;
export const RoundedCrossWrapper = styled(InputIconWrapper)`
  width: 13px;
  cursor: pointer;
`;